import React from 'react';
import { Helmet } from 'react-helmet';
import '../styles/Legal.css';

const TermsOfService: React.FC = () => {
  return (
    <div className="legal-container">
      <Helmet>
        <title>Terms of Service | aiNutrition</title>
        <meta name="description" content="Terms of Service for aiNutrition" />
      </Helmet>

      <div className="legal-content">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using aiNutrition (the "Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.
          </p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>
            aiNutrition is a platform that allows users to discover meal recipes based on available ingredients, generate nutritional information, and save favorite recipes.
          </p>
        </section>

        <section>
          <h2>3. User Conduct</h2>
          <p>
            You agree to use the Service in accordance with all applicable laws and regulations. You are solely responsible for your conduct and any content you submit, post, or display on the Service.
          </p>
          <p>
            <strong>Prohibited Uses:</strong> You agree not to use the Service to:
          </p>
          <ul>
            <li>Generate, create, or seek information about harmful, dangerous, illegal, or toxic recipes</li>
            <li>Search for recipes involving illegal substances, poisons, toxins, or harmful chemicals</li>
            <li>Attempt to bypass the platform's safety measures designed to prevent harmful content</li>
            <li>Create content that promotes, encourages, or provides instructions for illegal, harmful, or dangerous activities</li>
            <li>Harass, abuse, or harm another person</li>
            <li>Impersonate another user or person</li>
            <li>Violate the intellectual property rights of others</li>
          </ul>
        </section>

        <section>
          <h2>4. Content Safety and Moderation</h2>
          <p>
            aiNutrition implements various safety measures to prevent the generation of harmful recipes or the use of harmful ingredients. These measures include, but are not limited to:
          </p>
          <ul>
            <li>Filtering and blocking requests related to toxic, lethal, or illegal substances</li>
            <li>Monitoring and moderating user inputs for safety concerns</li>
            <li>Implementing automatic detection and prevention of harmful ingredient combinations</li>
          </ul>
          <p>
            While we strive to prevent all potential misuse, no system is perfect. If you encounter any content that you believe violates these terms, please report it immediately.
          </p>
        </section>

        <section>
          <h2>5. Account Termination</h2>
          <p>
            We reserve the right to terminate or suspend your account and access to the Service immediately, without prior notice or liability, for any breach of these Terms, including attempts to circumvent our safety measures or generate harmful content.
          </p>
        </section>

        <section>
          <h2>6. Disclaimer of Warranties</h2>
          <p>
            The Service is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not guarantee the accuracy, completeness, or safety of all recipes generated by our platform. Users should exercise caution and common sense when preparing any recipes.
          </p>
        </section>

        <section>
          <h2>7. Limitation of Liability</h2>
          <p>
            In no event shall aiNutrition, its operators, or its affiliates be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the Service or inability to access the Service.
          </p>
        </section>
        
        <section>
          <h2>8. Nutritional Information</h2>
          <p>
            While we strive for accuracy, the nutritional information provided through our Service is generated using AI and automated systems and should be considered an estimate only. Users with specific dietary needs, health conditions, or allergies should consult with healthcare professionals before making significant dietary changes.
          </p>
        </section>

        <section>
          <h2>9. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will provide notice of significant changes by updating the date at the top of these Terms. Your continued use of the Service after such modifications constitutes your acceptance of the updated Terms.
          </p>
        </section>

        <section>
          <h2>10. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which aiNutrition operates, without regard to its conflict of law provisions.
          </p>
        </section>

        <section>
          <h2>11. Contact Information</h2>
          <p>
            If you have any questions about these Terms, please contact us at support@ainutrition.com.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService; 